import React from 'react'
import Link from 'gatsby-link'

//  Components
import iconArrowUrl, { ReactComponent as IconArrow } from  '../../assets/svg/icon-arrow.svg'
import Button from '../Button/Button.js'

//  Styles
import styles from './Footer.module.scss';

const Footer = ({ siteYear, siteSubtitle }) => (
  <footer className={ styles.footer + " l-container"}>
    <div className={ styles.footer__top }>
      <h2 className={ styles.dataCenter__link }><a href="http://datacenter.commonwealthfund.org">The Commonwealth Fund <br />
      State Data Center</a></h2>
      {/* <h2 className={ styles.dataCenter__link }><a href="http://datacenter.commonwealthfund.org">The Commonwealth Fund <br />
      State Data Center</a></h2> */}
      <div className={ styles.subscribe }>
        <h3 className={ styles.subscribe__title }>Sign up to receive alerts and newsletters on the health policy topics you care about most.</h3>
        <Button href="http://www.commonwealthfund.org/account/register" className="button__primary__small" text="Sign Up" />
        {/* <form action="/" method="post" className={ styles.subscribeForm }>
          <input className={ styles.subscribeForm__input } id="Email" name="Email" placeholder="Your E-mail Address" type="email" />
          <input type="submit" className={styles.subscribeForm__submit } value="Submit" />
          <IconArrow className={ styles.subscribeForm__arrow } />
        </form>
        <form action="/" method="post" className="ng-pristine ng-valid" noValidate="novalidate">
          <input className="cwf-simpleform-input" data-val="true" data-val-email="The Email field is not a valid e-mail address." data-val-required="The Email field is required." id="Email" name="Email" placeholder="Your e-mail" required="" type="email" value=""/>
          <input autoComplete="false" id="contact_me_by_fax_only" name="contact_me_by_fax_only" style="display:none !important" tabIndex="-1" type="checkbox" value="true" className="hidden-field"/>
          <span className="custom checkbox"></span>
          <input name="contact_me_by_fax_only" type="hidden" value="false" />
          <input type="hidden" className="scroll-position" name="scrollPosition" />
          <input type="submit" className="cwf-simpleform-button" style="height: 30px;" value="Submit" />
          <span className="error">
            <span className="field-validation-valid" data-valmsg-for="Email" data-valmsg-replace="true"></span>
          </span>
          <IconArrow className={ styles.subscribeForm__arrow } />
        </form> */}
      </div>
    </div>
    <div className={ styles.footer__bottom }>
      <p className={ styles.copyright }>&copy;2018 The Commonwealth Fund</p>
      <p className={ styles.contactLink }>For more information about the report, contact <a href="http://www.commonwealthfund.org/about-us/staff-contact-information/program-staff/senior-program-research-staff/radley-david">David Radley</a> at the Commonwealth Fund.</p>
    </div>
  </footer>
)

export default Footer



// WEBPACK FOOTER //
// ./src/components/Footer/Footer.js